import { motion } from "framer-motion";
import { GALLERY } from "../../data/content";

export const Gallery = () => {
  return (
    <section
      id="work"
      data-testid="gallery-section"
      className="relative bg-background py-24 md:py-32 border-t border-border scroll-mt-16"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 md:mb-20 gap-6">
          <div>
            <p className="font-mono-ibm text-xs tracking-widest uppercase text-primary mb-4">
              / Selected Work
            </p>
            <h2 className="font-display uppercase leading-[0.88] tracking-tight text-5xl md:text-7xl lg:text-8xl">
              From Our
              <br />
              Floor
            </h2>
          </div>
          <p className="max-w-sm font-mono-ibm text-xs tracking-wide text-muted-foreground leading-relaxed">
            REAL CONSIGNMENTS FABRICATED AT WHITEFIELD — CRATES, FOAM FITMENTS
            AND EXPORT CARTONS, SHIPPED WORLDWIDE.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 md:grid-flow-row-dense auto-rows-[260px] gap-px bg-border border border-border">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.76, 0, 0.24, 1] }}
              className={`group relative bg-background overflow-hidden ${g.span}`}
            >
              <img
                src={g.src}
                alt={g.caption}
                className="w-full h-full object-cover img-industrial"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background/85 via-background/10 to-transparent opacity-80 group-hover:opacity-95 transition-opacity" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-5 md:p-6 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="font-mono-ibm text-[10px] md:text-xs tracking-widest uppercase text-primary block mb-1">
                  [ {String(i + 1).padStart(2, "0")} ]
                </span>
                <span className="font-display uppercase tracking-tight text-lg md:text-xl leading-tight">
                  {g.caption}
                </span>
              </figcaption>
              <span className="absolute inset-0 border-2 border-primary opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
